if ( typeof ProductQuantity !== 'function' ) {

	/*
	 * VFD: understøtter nu trin (step), så B2B-kunder går i hele kolli (6, 12, 18 …).
	 * Minimum, trin og maksimum læses fra inputfeltets min/step/max,
	 * som sættes ud fra Shopifys antalsregler i snippets/product-quantity.liquid.
	 */
	class ProductQuantity extends HTMLElement {

		constructor(){

			super();

			const qty = this.querySelector('.qty-selector'),
						qtyMinus = this.querySelector('.qty-minus'),
						qtyPlus = this.querySelector('.qty-plus'),
						qtyMin = qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1,
						qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999999,
						qtyStep = qty.getAttribute('step') && parseInt(qty.getAttribute('step')) > 0 ? parseInt(qty.getAttribute('step')) : 1;

			const updateButtons = () => {
				const current = parseInt(qty.value) || 0;
				qtyMinus.classList.toggle('disabled', current - qtyStep < qtyMin);
				qtyPlus.classList.toggle('disabled', current + qtyStep > qtyMax);
			};

			// Retter et indtastet antal til nærmeste gyldige antal (hele kolli)
			const snap = () => {
				let current = parseInt(qty.value);
				if ( isNaN(current) ) current = qtyMin;
				if ( qtyStep > 1 && current > 0 ) {
					current = Math.ceil(current / qtyStep) * qtyStep;
				}
				if ( current < qtyMin ) current = qtyMin;
				if ( current > qtyMax ) current = Math.floor(qtyMax / qtyStep) * qtyStep;
				if ( String(current) !== qty.value ) qty.value = current;
			};

			const announce = () => {
				qty.dispatchEvent(new CustomEvent('vfd:quantity', { bubbles: true, detail: { quantity: parseInt(qty.value) } }));
			};

			updateButtons();

			qty.addEventListener('change', ()=>{
				snap();
				updateButtons();
				announce();
			});

			qty.addEventListener('input', ()=>{
				updateButtons();
				announce();
			});

			qtyMinus.addEventListener('click', (e)=>{
				e.preventDefault();
				if ( ! qtyMinus.classList.contains('disabled') ) {
					const currentQty = parseInt(qty.value) || qtyMin;
					if ( currentQty - qtyStep >= qtyMin ) {
						qty.value = currentQty - qtyStep;
					}
					updateButtons();
					announce();
				}
			});

			qtyPlus.addEventListener('click', (e)=>{
				e.preventDefault();
				if ( ! qtyPlus.classList.contains('disabled') ) {
					const currentQty = parseInt(qty.value) || 0;
					if ( currentQty + qtyStep <= qtyMax ) {
						qty.value = currentQty + qtyStep;
					}
					updateButtons();
					announce();
				}
			});

		}

	}


  if ( typeof customElements.get('product-quantity') == 'undefined' ) {
    customElements.define('product-quantity', ProductQuantity);
	}

}
